document.querySelector("input.geo, select.geo").addEventListener("change", function (event) {

	var countryElement = event.target;
	var country = countryElement.value;

	// State

	var stateElement = document.querySelector(countryElement.dataset.geoState);
	var stateSelectElement = document.getElementById(stateElement.getAttribute("id")+"Select");

	if (geoSelectorStates[country]) {
		stateSelectElement.innerHTML = "";
		stateSelectElement.add(new Option("-- Please select --", ""));
		Object.entries(geoSelectorStates[country]).forEach(([key, value]) => {
			stateSelectElement.add(new Option(value, key));
		});
		stateSelectElement.value = stateElement.value;
		shownElement = stateSelectElement;
		hiddenElement = stateElement;
	}
	else {
		shownElement = stateElement;
		hiddenElement = stateSelectElement;
	}

	hiddenElement.value = "";
	hiddenElement.classList.add("d-none");
	hiddenElement.setAttribute("disabled", "");
	shownElement.classList.remove("d-none");
	shownElement.removeAttribute("disabled");

	// Postal code

	var postalCodeElement = document.querySelector(countryElement.dataset.geoPostalCode);

	if (postalCodeElement)
	{
		postalCodeElement.dataset.country = countryElement.value;

		if (typeof Inputmask === "function")
		{
			if (countryElement.value == 'USA')
				mask = ["99999", "99999-9999"];
			else
				mask = "";

			Inputmask({
				mask: mask
			}).mask(postalCodeElement);
		}
	}
});

document.querySelector("input.geo, select.geo").dispatchEvent(new Event("change"));
